import { parseAnswer, stripConsensusTags } from "../utils/evidenceParser";
import { formatEvidenceLevel } from "../utils/format";

interface AnswerSectionProps {
  answer: string;
}

export function AnswerSection({ answer }: AnswerSectionProps) {
  const cleaned = stripConsensusTags(answer);
  const segments = parseAnswer(cleaned);

  if (!segments.length) {
    return <p className="muted-empty">No synthesized answer available.</p>;
  }

  return (
    <div className="answer-body">
      {segments.map((seg, i) => {
        if (seg.kind === "text") {
          return (
            <p key={i} className="answer-para">
              {seg.content}
            </p>
          );
        }
        if (seg.kind === "fallback") {
          return (
            <pre key={i} className="answer-fallback">
              {seg.content}
            </pre>
          );
        }
        const ev = seg.evidence!;
        return (
          <div key={i} className="evidence-card">
            <blockquote>&ldquo;{ev.excerpt}&rdquo;</blockquote>
            <p className="ev-title">{ev.title}</p>
            {ev.url ? (
              <a href={ev.url} target="_blank" rel="noreferrer" className="ev-link">
                {ev.url}
              </a>
            ) : null}
            <div className="ev-chips">
              {ev.rcs != null ? <span className="meta-chip">RCS {ev.rcs}/10</span> : null}
              {ev.level ? (
                <span className="meta-chip">{formatEvidenceLevel(ev.level)}</span>
              ) : null}
              {ev.citations != null ? (
                <span className="meta-chip">cited {ev.citations}</span>
              ) : null}
              {ev.year != null ? <span className="meta-chip">year {ev.year}</span> : null}
              {ev.journalQ != null ? (
                <span className="meta-chip">journal Q {ev.journalQ}/5</span>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
